import { initializeConnector, Web3ReactHooks } from '@web3-react/core'
import { MetaMask } from '@web3-react/metamask'
import { Connector } from '@web3-react/types'
import { WalletConnect } from '@web3-react/walletconnect'
import { URLS } from 'utils/web3/chains'

export enum WalletTypes {
  MetaMask = 'MetaMask',
  WalletConnect = 'WalletConnect',
}

export function getConnectorName(connector: Connector) {
  if (connector instanceof MetaMask) return WalletTypes.MetaMask
  if (connector instanceof WalletConnect) return WalletTypes.WalletConnect
  return 'Unknown'
}

function onError(error: Error) {
  console.debug(`web3-react error: ${error}`)
}

export const [metaMask, metaMaskHooks] = initializeConnector<MetaMask>(
  (actions) =>
    new MetaMask({
      actions,
      onError,
    })
)

export const [walletConnect, walletConnectHooks] =
  initializeConnector<WalletConnect>(
    (actions) =>
      new WalletConnect({
        actions,
        options: {
          rpc: URLS,
          qrcode: true,
        },
        onError,
      })
  )

const connectors: [MetaMask | WalletConnect, Web3ReactHooks][] = [
  [metaMask, metaMaskHooks],
  [walletConnect, walletConnectHooks],
]

export default connectors
